import { del, get, post, put } from "./api_helper"
import * as url from "./url_helper"
import {NotificationManager} from "react-notifications";


const getCategoriesPromotionsAPI = data => get(url.GET_CATEGORIES_PROMOTIONS.concat('/').concat(data))
    .catch(err => {
        const {title, message} = err.response.data;
        NotificationManager.error(message, title);
        throw err.response.data
    })


export {
    getCategoriesPromotionsAPI
}
